import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'appSrc/components/UI';
import AdminWrapperRedirect from 'appSrc/components/Auth/AdminWrapperRedirect';
import { DL_COLORS } from 'appSrc/utils';
import style from './styles/style.module.css';

import Router from './Router';


class Home extends PureComponent {
    render() {
        const { location } = this.props;

        const pathname = location.pathname;

        return (
            <section className={ style.adminPanel }>
                <Helmet>
                    <title>Admin</title>
                </Helmet>
                <div className={ style.navigation }>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/?$/ ) } >
                        <Link to='/admin' data-hook='admin-menu-dashboard'>Dashboard</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/users/ ) } >
                        <Link to='/admin/users' data-hook='admin-menu-users'>Users</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/categories/ ) } >
                        <Link to='/admin/categories' data-hook='admin-menu-channels'>Categories</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/content/ ) } >
                        <Link to='/admin/content' data-hook='admin-menu-articles'>Content</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/carousels/ ) } >
                        <Link to='/admin/carousels' data-hook='admin-menu-carousels'>Carousels</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/products/ ) } >
                        <Link to='/admin/products' data-hook='admin-menu-products'>Products</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/videos/ ) } >
                        <Link to='/admin/videos' data-hook='admin-menu-videos'>Videos</Link>
                    </div>
                    {/* <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/reviews/ ) } >
                        <Link to='/admin/reviews' data-hook='admin-menu-reviews'>Reviews</Link>
                    </div> */}
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/affiliates/ ) } >
                        <Link to='/admin/affiliates' data-hook='admin-menu-products'>Affiliates</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/tags/ ) } >
                        <Link to='/admin/tags' data-hook='admin-menu-tags'>Tags</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/professions/ ) } >
                        <Link to='/admin/professions' data-hook='admin-menu-professions'>Professions</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/site-copy/ ) } >
                        <Link to='/admin/site-copy' data-hook='admin-menu-site-copy'>Site Copy</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/vanity-links/ ) } >
                        <Link to='/admin/vanity-links' data-hook='admin-menu-vanity-links'>Vanity URLs</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/search/ ) } >
                        <Link to='/admin/search' data-hook='admin-menu-search'>Elastic Search</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/reports/ ) } >
                        <Link to='/admin/reports' data-hook='admin-menu-reports'>Reports</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/homepage\/homepage_hero/ ) } >
                        <Link to='/admin/homepage/homepage_hero' data-hook='admin-menu-homepage'>Homepage</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/cta/ ) } >
                        <Link to='/admin/ctas/contexts' data-hook='admin-menu-cta'>Action Items</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/brands/ ) } >
                        <Link to='/admin/brands' data-hook='admin-menu-brands'>Brands</Link>
                    </div>
                    <div className={ style.navItem }
                    data-active={ !!pathname.match( /^\/admin\/qr/ ) } >
                        <Link to='/admin/qr_codes' data-hook='admin-menu-qr-codes'>QR Codes</Link>
                    </div>

                    <div className={ style.navItem }>
                        <ExternalLink to='https://docs.google.com/forms/d/e/1FAIpQLSfCw_xP1hCCEqh4XvtJaKGqkcvm5_CQyeqqAXEwgAwSjfnFfw/viewform?usp=sf_link'
                        style={ { color: DL_COLORS.primary } }>
                            Feature Request
                        </ExternalLink>
                    </div>
                    <div className={ style.navItem }>
                        <ExternalLink to='https://docs.google.com/forms/d/1GIajAyhknwTu4gVhZsY5vFiOAErV0tiHCFryDd2iMtc/viewform?ts=5f0df087&edit_requested=true'
                        style={ { color: DL_COLORS.primary } }>
                            Content Change Request
                        </ExternalLink>
                    </div>
                    <div className={ style.navItem }>
                        <ExternalLink to='https://forms.gle/8ttg2jhDkxshpiWa6'
                        style={ { color: DL_COLORS.primary } }>
                            Video Content Request
                        </ExternalLink>
                    </div>
                    <div className={ style.navItem }>
                        <ExternalLink to='https://forms.gle/bSCVem2eBJ69Yabd6'
                        style={ { color: DL_COLORS.primary } }>
                            Video Post-Production Request
                        </ExternalLink>
                    </div>
                </div>
                <div className={ style.contentWrapper }>
                    <div className={ style.content }>
                        <Router />
                    </div>
                </div>
            </section>
        );
    }
}

export default AdminWrapperRedirect( connect()( Home ) );
